import { useEffect, useState } from "react";
import Input from "../../extra/Input";
import SettingBox from "./SettingBox";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getSetting,
  updateSetting,
  handleToggleSwitch,
  handleSellerToggleSwitch,
} from "../../store/setting/setting.action";
import { getWithdraw } from "../../store/withdraw/withdraw.action";
import Button from "../../extra/Button";

import { set } from "date-fns";
import ToggleSwitch from "../../extra/ToggleSwitch";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import InfoTooltip from "../../extra/InfoTooltip";
import { auctionSetting, chargesSetting, openAISetting, privateKeyJson, resendApiSetting, withdrawalSetting, zegoApp } from "../../extra/infoContent";
import { usePermission } from "../../../hooks/usePermission";

const Setting = (props) => {

  const { can } = usePermission();
  const canEdit = can("Setting", "Edit");

  const { setting } = useSelector((state) => state.setting);

  const parseJsonLoose = (value, fallback) => {
    const normalized = (value || fallback).replace(/,(\s*[}\]])/g, "$1");
    return JSON.parse(normalized);
  };



  const dispatch = useDispatch();
  // box 1
  const [settingId, setSettingId] = useState("");
  const [zegoAppId, setZegoAppId] = useState("");
  const [paymentReminderForLiveAuction, setPaymentReminderForLiveAuction] = useState("");
  const [minPayout, setMinPayout] = useState("");
  const [paymentReminderForManualAuction, setPaymentReminderForManualAuction] = useState("");
  const [zegoAppSignIn, setZegoAppSignIn] = useState("");
  // box 2
  // const [privacyPolicyLink, setPrivacyPolicyLink] = useState("");
  // const [privacyPolicyText, setPrivacyPolicyText] = useState("");
  const [resendkey, setResendKey] = useState("");
  // const [termsAndConditionsLink, setTermsAndConditionsLink] = useState('');
  const [openaiApiKey, setOpenaiApiKey] = useState("");



  const [cancelOrderCharges, setCancelOrderCharges] = useState("");
  const [adminCommissionCharges, setAdminCommissionCharges] = useState("");

  const [isFakeData, setIsFakeData] = useState(false);

  const [androidAssetLinks, setAndroidAssetLinks] = useState("");
  const [appleAppSiteAssociation, setAppleAppSiteAssociation] = useState("");

  // box 3

  // box 7
  const [isAddProductRequest, setIsAddProductRequest] = useState(false);
  const [isUpdateProductRequest, setIsUpdateProductRequest] = useState(false);
  const [privateKey, setPrivateKey] = useState("");

  const [addressProofRequired, setAddressProofRequired] = useState(setting?.addressProofRequired || false);
  const [addressProofActive, setAddressProofActive] = useState(setting?.addressProofActive || false);

  const [govIdRequired, setGovIdRequired] = useState(setting?.govIdRequired || false);
  const [govIdActive, setGovIdActive] = useState(setting?.govIdActive || false);

  const [registrationCertRequired, setRegistrationCertRequired] = useState(setting?.registrationCertRequired || false);
  const [registrationCertActive, setRegistrationCertActive] = useState(setting?.registrationCertActive || false);


  const onToggle = (fieldKey, type) => {

    handleClick(fieldKey + (type === "required" ? "Required" : "Active"));
    // The store update logic presumably will update the global setting state and re-render accordingly.
  };

  // error

  const [error, setError] = useState({
    zegoAppId: "",
    paymentReminderForLiveAuction: "",
    minPayout: "",
    paymentReminderForManualAuction: "",
    zegoAppSignIn: "",
    // privacyPolicyLink: "",
    resendKey: "",
    // termsAndConditionsLink: "",
    openaiApiKey: "",
    // privacyPolicyText: "",
    // shippingCharges: "",
    withdrawCharges: "",
    withdrawLimit: "",
    cancelOrderCharges: "",
    adminCommissionCharges: "",
    razorPayId: "",
    razorSecretKey: "",
    stripePublishableKey: "",
    stripeSecretKey: "",
    privateKey: "",
    androidAssetLinks: "",
    appleAppSiteAssociation: "",
  });


  useEffect(() => {

    dispatch(getSetting());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getWithdraw());
  }, [dispatch]);

  //onselect function of selecting multiple values

  //onRemove function for remove multiple values

  useEffect(() => {


    setSettingId(setting?._id);
    // box 1
    setZegoAppId(setting?.zegoAppId);
    setPaymentReminderForLiveAuction(setting?.paymentReminderForLiveAuction);
    setMinPayout(setting?.minPayout);
    setPaymentReminderForManualAuction(setting?.paymentReminderForManualAuction);
    setZegoAppSignIn(setting?.zegoAppSignIn);
    // box 2
    // setPrivacyPolicyLink(setting?.privacyPolicyLink);
    // setPrivacyPolicyText(setting?.privacyPolicyText);
    setIsFakeData(setting?.isFakeData);

    // box 7
    setIsAddProductRequest(setting?.isAddProductRequest);
    setIsUpdateProductRequest(setting?.isUpdateProductRequest);
    setPrivateKey(JSON.stringify(setting?.privateKey));
    setAdminCommissionCharges(setting?.adminCommissionCharges);
    setCancelOrderCharges(setting?.cancelOrderCharges);
    setResendKey(setting?.resendApiKey);
    // setTermsAndConditionsLink(setting?.termsAndConditionsLink || '');
    setOpenaiApiKey(setting?.openaiApiKey);
    setAndroidAssetLinks(
      setting?.androidAssetLinks
        ? JSON.stringify(setting?.androidAssetLinks, null, 2)
        : "[]"
    );
    setAppleAppSiteAssociation(
      setting?.appleAppSiteAssociation
        ? JSON.stringify(setting?.appleAppSiteAssociation, null, 2)
        : "{}"
    );
  }, [setting]);

  const handleSubmit = () => {

    let parsedAndroidAssetLinks = [];
    let parsedAppleAppSiteAssociation = {};

    try {
      parsedAndroidAssetLinks = parseJsonLoose(androidAssetLinks, "[]");
      if (!Array.isArray(parsedAndroidAssetLinks)) {
        return setError({
          ...error,
          androidAssetLinks: "Android Asset Links must be a JSON array",
        });
      }
      if (
        parsedAndroidAssetLinks.some(
          (item) => !item || Array.isArray(item) || typeof item !== "object"
        )
      ) {
        return setError({
          ...error,
          androidAssetLinks: "Android Asset Links must be an array of objects",
        });
      }
    } catch (err) {
      return setError({
        ...error,
        androidAssetLinks: "Invalid JSON for Android Asset Links",
      });
    }

    try {
      parsedAppleAppSiteAssociation = JSON.parse(appleAppSiteAssociation || "{}");
      if (
        !parsedAppleAppSiteAssociation ||
        Array.isArray(parsedAppleAppSiteAssociation) ||
        typeof parsedAppleAppSiteAssociation !== "object"
      ) {
        return setError({
          ...error,
          appleAppSiteAssociation:
            "Apple App Site Association must be a JSON object",
        });
      }
    } catch (err) {
      return setError({
        ...error,
        appleAppSiteAssociation: "Invalid JSON for Apple App Site Association",
      });
    }

    if (
      !zegoAppId ||
      !paymentReminderForLiveAuction ||
      !minPayout ||
      !paymentReminderForManualAuction ||
      !zegoAppSignIn ||
      // !privacyPolicyLink ||
      !resendkey ||
      // !termsAndConditionsLink ||
      !openaiApiKey ||
      // !privacyPolicyText ||

      !cancelOrderCharges ||
      cancelOrderCharges <= 0 ||
      !adminCommissionCharges ||
      adminCommissionCharges <= 0
    ) {
      let error = {};
      if (!zegoAppId) error.zegoAppId = "ZegoAppId Is Required ";
      if (!paymentReminderForLiveAuction)
        error.paymentReminderForLiveAuction =
          "Payment Reminder For Live Auction Is Required ";
      if (!minPayout) error.minPayout = "Min Payout Is Required ";
      if (!paymentReminderForManualAuction)
        error.paymentReminderForManualAuction =
          "Payment Reminder For Manual Auction Is Required ";
      if (!zegoAppSignIn) error.zegoAppSignIn = "ZegoAppSignIn Is Required ";
      // if (!privacyPolicyLink)
      //   error.privacyPolicyLink = "Privacy Policy Link Is Required ";
      if (!resendkey)
        error.resendKey = "Resend Api Key Is Required ";
      // if (!termsAndConditionsLink)
      //   error.termsAndConditionsLink = "Terms And Conditions Link Is Required ";
      if (!openaiApiKey)
        error.openaiApiKey = "Openai Api Key Is Required ";
      // if (!privacyPolicyText)
      //   error.privacyPolicyText = "Privacy Policy Text Is Required ";

      if (!cancelOrderCharges)
        error.cancelOrderCharges = "Cancel Order Charges Is Required";
      if (cancelOrderCharges <= 0)
        error.cancelOrderCharges = "Enter Correct Cancel Order Charges";

      if (!adminCommissionCharges)
        error.adminCommissionCharges = "Admin Commission Charges Is Required";
      if (adminCommissionCharges <= 0)
        error.adminCommissionCharges =
          "Enter Correct Admin Commission Charges ";

      return setError({ ...error });
    } else {

      let settingData = {
        zegoAppId,
        paymentReminderForLiveAuction,
        minPayout,
        paymentReminderForManualAuction,
        zegoAppSignIn,
        // privacyPolicyLink,
        resendApiKey: resendkey,
        // termsAndConditionsLink,
        openaiApiKey,
        // privacyPolicyText,
        privateKey,
        adminCommissionCharges,
        cancelOrderCharges,
      };

      if (Array.isArray(parsedAndroidAssetLinks) && parsedAndroidAssetLinks.length) {
        settingData.androidAssetLinks = parsedAndroidAssetLinks;
      }

      if (
        parsedAppleAppSiteAssociation &&
        typeof parsedAppleAppSiteAssociation === "object" &&
        !Array.isArray(parsedAppleAppSiteAssociation) &&
        Object.keys(parsedAppleAppSiteAssociation).length
      ) {
        settingData.appleAppSiteAssociation = parsedAppleAppSiteAssociation;
      }

      props.updateSetting(settingData, setting?._id);
    }
  };

  const handleClick = (toggleType) => {

    props.handleToggleSwitch(setting._id, toggleType, setting);
  };

  const handleSellerToggle = (field, toggleType) => {
    //Handle Update Switch Value

    dispatch(handleSellerToggleSwitch(setting._id, field, toggleType));
  };


  // const handleClick = (field, toggleType) => {
  //   

  //   // Prepare toggled values based on current setting
  //   let newIsRequired = setting[field]?.isRequired;
  //   let newIsActive = setting[field]?.isActive;

  //   if (toggleType === "isRequired") {
  //     newIsRequired = !newIsRequired;
  //     // If isRequired turned true and isActive is false, force isActive true
  //     if (newIsRequired === true && newIsActive === false) {
  //       newIsActive = true;
  //       // Dispatch twice or modify action to handle both toggles together
  //       dispatch(handleSellerToggleSwitch(setting._id, field, "isRequired", newIsRequired));
  //       dispatch(handleSellerToggleSwitch(setting._id, field, "isActive", newIsActive));
  //       return;
  //     }
  //   } else if (toggleType === "isActive") {
  //     newIsActive = !newIsActive;
  //   }

  //   // Normal single dispatch if above condition not triggered
  //   dispatch(handleSellerToggleSwitch(setting._id, field, toggleType));
  // };


  return (
    <>
      <div className="mainup">


        <div className="settingHeader primeHeader">
          <div className="col-12 headname" style={{ marginTop: "15px", marginBottom: "-5px", marginLeft: "2px" }}>App Setting </div>
        </div>
        <div className="settingMain">
          <div className="row" style={{ margin: "0px 2px" }}>
            {/*-------------- Box 1 --------------*/}
            <SettingBox>
              <div
                className="col-12 mb-3"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className="mainTitle w-100">{`Zegocloud Setting`}</div>
                <InfoTooltip
                  title="Zegocloud Setting"
                  content={zegoApp}
                />
              </div>
              <Input
                type={`text`}
                label={`Zegocloud App Id`}
                value={zegoAppId}
                newClass={`col-12`}
                placeholder={`Enter Your Zegocloud App Id....`}
                errorMessage={error.zegoAppId && error.zegoAppId}
                onChange={(e) => {
                  setZegoAppId(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      zegoAppId: `Zegocloud App Id Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      zegoAppId: "",
                    });
                  }
                }}
              />
              <Input
                type={`text`}
                label={`Zegocloud App Sign In`}
                value={zegoAppSignIn}
                newClass={`col-12`}
                errorMessage={error.zegoAppSignIn && error.zegoAppSignIn}
                onChange={(e) => {
                  setZegoAppSignIn(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      zegoAppSignIn: `Zegocloud App Sign In Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      zegoAppSignIn: "",
                    });
                  }
                }}
              />

            </SettingBox>


            <SettingBox>
              <div
                className="col-12 mb-3"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className="mainTitle w-100">{`Auction Setting`}</div>
                <InfoTooltip
                  title="Auction Setting"
                  content={auctionSetting}
                />
              </div>
              <Input
                type={`number`}
                label={`Payment Reminder For LiveAuction (In Minutes)`}
                value={paymentReminderForLiveAuction}
                newClass={`col-12`}
                placeholder={`Enter Your Zegocloud App Id....`}
                errorMessage={error.paymentReminderForLiveAuction && error.paymentReminderForLiveAuction}
                onChange={(e) => {
                  setPaymentReminderForLiveAuction(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      paymentReminderForLiveAuction: `Payment Reminder For LiveAuction (In Minutes) Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      paymentReminderForLiveAuction: "",
                    });
                  }
                }}
              />
              <Input
                type={`number`}
                label={`Payment Reminder For ManualAuction (In Minutes)`}
                value={paymentReminderForManualAuction}
                newClass={`col-12`}
                errorMessage={error.paymentReminderForManualAuction && error.paymentReminderForManualAuction}
                onChange={(e) => {
                  setPaymentReminderForManualAuction(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      paymentReminderForManualAuction: `Payment Reminder For ManualAuction (In Minutes) Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      paymentReminderForManualAuction: "",
                    });
                  }
                }}
              />

            </SettingBox>

            {/*-------------- Box 2 --------------*/}
            {/* <SettingBox title={`App Setting`}>
              <Input
                type={`text`}
                label={`Privacy Policy Link ( redirect user to this link in app )`}
                value={privacyPolicyLink}
                newClass={`col-12`}
                placeholder={`Enter You Privacy Policy Link....`}
                errorMessage={
                  error.privacyPolicyLink && error.privacyPolicyLink
                }
                onChange={(e) => {
                  setPrivacyPolicyLink(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      privacyPolicyLink: `Privacy Policy Link Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      privacyPolicyLink: "",
                    });
                  }
                }}
              />

              <Input
                type={`text`}
                label={`Privacy Policy Text`}
                value={privacyPolicyText}
                newClass={`col-12`}
                placeholder={`Enter You Privacy Policy Text....`}
                errorMessage={
                  error.privacyPolicyText && error.privacyPolicyText
                }
                onChange={(e) => {
                  setPrivacyPolicyText(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      privacyPolicyText: `Privacy Policy Text Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      privacyPolicyText: "",
                    });
                  }
                }}
              />
            </SettingBox> */}

            {/* Box 7 */}
            <SettingBox
              title={`Add Product Request`}
              title2={`New product request enable/disable for seller`}
              toggleSwitch={{
                switchValue: isAddProductRequest,
                // handleClick: () => {
                //   handleClick("productRequest");
                // },
                handleClick: canEdit ? () => handleClick("productRequest") : null,
              }}
            ></SettingBox>
            <SettingBox
              title={`Update Product Request`}
              title2={`Enable/disable product request update for seller`}
              toggleSwitch={{
                switchValue: isUpdateProductRequest,
                // handleClick: () => {
                //   handleClick("updateProductRequest");
                // },
                handleClick: canEdit ? () => handleClick("updateProductRequest") : null,
              }}
            ></SettingBox>

            <SettingBox>
              <div
                className="col-12 mb-3"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className="mainTitle w-100">{`Charges Setting`}</div>
                <InfoTooltip
                  title="Charges Setting"
                  content={chargesSetting}
                />
              </div>
              <Input
                type={`number`}
                label={`Cancel Order Charges (%)`}
                value={cancelOrderCharges}
                newClass={`col-6 pb-2`}
                placeholder={`Enter You Cancle Order Charge....`}
                errorMessage={
                  error.cancelOrderCharges && error.cancelOrderCharges
                }
                onChange={(e) => {
                  setCancelOrderCharges(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      cancelOrderCharges: `Cancle Order ChargeIs Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      cancelOrderCharges: "",
                    });
                  }
                }}
              />

              <Input
                type={`number`}
                label={`Admin Commission Charges (%)`}
                value={adminCommissionCharges}
                newClass={`col-6`}
                placeholder={`Enter You Admin Commission Charges`}
                errorMessage={
                  error.adminCommissionCharges && error.adminCommissionCharges
                }
                onChange={(e) => {
                  setAdminCommissionCharges(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      adminCommissionCharges: `Admin Commission Charges Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      adminCommissionCharges: "",
                    });
                  }
                }}
              />

              {/* <div style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end"
              }}>
                <InfoTooltip
                  title="Charges Setting"
                  content={chargesSetting}
                />
              </div> */}
            </SettingBox>

            <SettingBox>
              <div
                className="col-12 mb-3"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className="mainTitle w-100">{`Resend API Setting`}</div>
                <InfoTooltip
                  title="Resend API Setting"
                  content={resendApiSetting}
                />
              </div>
              <Input
                type={`text`}
                label={`Resend Api Key`}
                value={resendkey}
                newClass={`col-12`}
                placeholder={`Enter You Resend Api Key here`}
                errorMessage={
                  error.resendKey && error.resendKey
                }
                onChange={(e) => {
                  setResendKey(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      resendKey: `Resend Api Key Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      resendKey: "",
                    });
                  }
                }}
              />


            </SettingBox>

            <SettingBox>
              <div
                className="col-12 mb-3"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className="mainTitle w-100">{`Minimum Withdrawal Limit (Seller) (${setting?.currency?.currencyCode})`}</div>
                <InfoTooltip
                  title="Minimum Withdrawal Limit (Seller)"
                  content={withdrawalSetting}
                />
              </div>
              <Input
                type={`number`}
                label={`Minimum Withdrawal Amount`}
                value={minPayout}
                newClass={`col-12`}
                placeholder={`Enter Amount....`}
                errorMessage={error.minPayout && error.minPayout}
                onChange={(e) => {
                  setMinPayout(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      minPayout: `Minimum Withdrawal Amount Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      minPayout: "",
                    });
                  }
                }}
              />
              {/* 
              <div style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end"
              }}>
                <InfoTooltip
                  title="Withdrawal Setting"
                  content={withdrawalSetting}
                />
              </div> */}

            </SettingBox>

            <SettingBox>
              <div
                className="col-12 mb-3"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className="mainTitle w-100">{`Open AI Key Setting`}</div>
                <InfoTooltip
                  title="Open AI Key Setting"
                  content={openAISetting}
                />
              </div>
              <Input
                type={`text`}
                label={`Open AI Key`}
                value={openaiApiKey}
                newClass={`col-12`}
                placeholder={`Enter You Open AI Key here`}
                errorMessage={
                  error.openaiApiKey && error.openaiApiKey
                }
                onChange={(e) => {
                  setOpenaiApiKey(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      openaiApiKey: `Open AI Key Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      openaiApiKey: "",
                    });
                  }
                }}
              />

            </SettingBox>



            <SettingBox>
              <div
                className="col-12 mb-3"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className="mainTitle w-100">{`Firebase Notification Setting`}</div>
                <InfoTooltip
                  title="Firebase Notification Setting"
                  content={privateKeyJson}
                />
              </div>
              <div className="prime-input">
                <label
                  className="float-left styleForTitle"
                  style={{
                    color: "#999AA4"
                  }}
                  htmlFor="privateKey"
                >
                  Private Key JSON ( To handle firebase push notification )
                </label>
                <textarea
                  name=""
                  className="form-control mt-2"
                  id="privateKey"
                  rows={10}
                  value={privateKey}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    try {
                      const newData = JSON.parse(newValue);
                      setPrivateKey(newValue);
                      setError("");
                    } catch (error) {
                      // Handle invalid JSON input
                      console.error("Invalid JSON input:", error);
                      setPrivateKey(newValue);
                      return setError({
                        ...error,
                        privateKey: "Invalid JSON input",
                      });
                    }
                  }}
                ></textarea>

                {error.privateKey && (
                  <div className="pl-1 text-left">
                    <p className="errorMessage">{error.privateKey}</p>
                  </div>
                )}
              </div>
            </SettingBox>


            <SettingBox title={`Become Seller Setting`} className="mb-5">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div style={{ width: "200px" }} />
                <span className="fw-semibold" style={{ width: "80px", textAlign: "center" }}>Require</span>
                <span className="fw-semibold" style={{ width: "80px", textAlign: "center" }}>Active</span>
              </div>

              {/* Address Proof Row */}
              <div className="d-flex justify-content-between align-items-center mt-2">
                <h5 className="me-2 fw-semibold" style={{ width: "200px" }}>Address Proof</h5>
                <div style={{ width: "80px", textAlign: "center" }}>
                  <ToggleSwitch
                    value={setting?.addressProof?.isRequired}
                    onClick={() => {
                      handleSellerToggle("addressProof", "isRequired");
                      if (setting?.addressProof?.isActive === false && setting?.addressProof?.isRequired === false) {
                        setTimeout(() => {
                          handleSellerToggle("addressProof", "isActive");
                        }, 1000); // 2 second delay, apko jitna chahiye adjust kar sakte hain
                      }
                    }}
                    disabled={!canEdit}
                  />
                </div>
                <div style={{ width: "80px", textAlign: "center" }}>
                  <ToggleSwitch
                    value={setting?.addressProof?.isActive}
                    onClick={() => {
                      handleSellerToggle("addressProof", "isActive");
                      if (setting?.addressProof?.isRequired === true && setting?.addressProof?.isActive === true) {
                        setTimeout(() => {
                          handleSellerToggle("addressProof", "isRequired");
                        }, 1000);
                      }
                    }}
                    disabled={!canEdit}
                  />
                </div>
              </div>


              {/* Government ID Row */}
              <div className="d-flex justify-content-between align-items-center mt-2">
                <h5 className="me-2 fw-semibold" style={{ width: "200px" }}>Government ID</h5>
                <div style={{ width: "80px", textAlign: "center" }}>
                  <ToggleSwitch
                    value={setting?.govId?.isRequired}
                    onClick={() => {
                      handleSellerToggle("govId", "isRequired");
                      if (setting?.govId?.isActive === false && setting?.govId?.isRequired === false) {
                        setTimeout(() => {
                          handleSellerToggle("govId", "isActive");
                        }, 1000);
                      }
                    }}
                    disabled={!canEdit}
                  />
                </div>
                <div style={{ width: "80px", textAlign: "center" }}>
                  <ToggleSwitch
                    value={setting?.govId?.isActive}
                    onClick={() => {
                      handleSellerToggle("govId", "isActive");
                      if (setting?.govId?.isRequired === true && setting?.govId?.isActive === true) {
                        setTimeout(() => {
                          handleSellerToggle("govId", "isRequired");
                        }, 1000);
                      }
                    }}
                    disabled={!canEdit}
                  />
                </div>
              </div>

              {/* Registration Certificate Row */}
              <div className="d-flex justify-content-between align-items-center mt-2">
                <h5 className="me-2 fw-semibold" style={{ width: "200px", whiteSpace: "nowrap" }}>Registration Certificate</h5>
                <div style={{ width: "80px", textAlign: "center" }}>
                  <ToggleSwitch
                    value={setting?.registrationCert?.isRequired}
                    onClick={() => {
                      handleSellerToggle("registrationCert", "isRequired");
                      if (setting?.registrationCert?.isActive === false && setting?.registrationCert?.isRequired === false) {
                        setTimeout(() => {
                          handleSellerToggle("registrationCert", "isActive");
                        }, 1000);
                      }
                    }}
                    disabled={!canEdit}
                  />
                </div>
                <div style={{ width: "80px", textAlign: "center" }}>
                  <ToggleSwitch
                    value={setting?.registrationCert?.isActive}
                    onClick={() => {
                      handleSellerToggle("registrationCert", "isActive");
                      if (setting?.registrationCert?.isRequired === true && setting?.registrationCert?.isActive === true) {
                        setTimeout(() => {
                          handleSellerToggle("registrationCert", "isRequired");
                        }, 1000);
                      }
                    }}
                    disabled={!canEdit}
                  />
                </div>
              </div>
            </SettingBox>


            <SettingBox>
              <div
                className="col-12 mb-3"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className="mainTitle w-100">{`App Links Setting`}</div>
              </div>

              <div className="prime-input">
                <label
                  className="float-left styleForTitle"
                  style={{
                    color: "#999AA4"
                  }}
                  htmlFor="androidAssetLinks"
                >
                  Android Asset Links JSON Array
                </label>
                <textarea
                  name=""
                  className="form-control mt-2"
                  id="androidAssetLinks"
                  rows={8}
                  value={androidAssetLinks}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    setAndroidAssetLinks(newValue);
                    try {
                      const parsed = parseJsonLoose(newValue, "[]");
                      if (!Array.isArray(parsed)) {
                        return setError({
                          ...error,
                          androidAssetLinks: "Android Asset Links must be a JSON array",
                        });
                      }
                      if (
                        parsed.some(
                          (item) => !item || Array.isArray(item) || typeof item !== "object"
                        )
                      ) {
                        return setError({
                          ...error,
                          androidAssetLinks: "Android Asset Links must be an array of objects",
                        });
                      }
                      return setError({
                        ...error,
                        androidAssetLinks: "",
                      });
                    } catch (err) {
                      return setError({
                        ...error,
                        androidAssetLinks: "Invalid JSON for Android Asset Links",
                      });
                    }
                  }}
                ></textarea>

                {error.androidAssetLinks && (
                  <div className="pl-1 text-left">
                    <p className="errorMessage">{error.androidAssetLinks}</p>
                  </div>
                )}
              </div>

              <div className="prime-input mt-3">
                <label
                  className="float-left styleForTitle"
                  style={{
                    color: "#999AA4"
                  }}
                  htmlFor="appleAppSiteAssociation"
                >
                  Apple App Site Association JSON Object
                </label>
                <textarea
                  name=""
                  className="form-control mt-2"
                  id="appleAppSiteAssociation"
                  rows={8}
                  value={appleAppSiteAssociation}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    setAppleAppSiteAssociation(newValue);
                    try {
                      const parsed = JSON.parse(newValue || "{}");
                      if (!parsed || Array.isArray(parsed) || typeof parsed !== "object") {
                        return setError({
                          ...error,
                          appleAppSiteAssociation:
                            "Apple App Site Association must be a JSON object",
                        });
                      }
                      return setError({
                        ...error,
                        appleAppSiteAssociation: "",
                      });
                    } catch (err) {
                      return setError({
                        ...error,
                        appleAppSiteAssociation:
                          "Invalid JSON for Apple App Site Association",
                      });
                    }
                  }}
                ></textarea>

                {error.appleAppSiteAssociation && (
                  <div className="pl-1 text-left">
                    <p className="errorMessage">{error.appleAppSiteAssociation}</p>
                  </div>
                )}
              </div>
            </SettingBox>


            <SettingBox
              title={`Fake Data`}
              title2={`Disable/Enable fake data in app`}
              toggleSwitch={{
                switchName: " ",
                switchValue: isFakeData,
                // handleClick: () => {
                //   handleClick("isFakeData");
                // },
                handleClick: canEdit ? () => handleClick("isFakeData") : null,
              }}
            >
            </SettingBox>

          </div>
          <div className="row mt-5">
            <div className="col-12 d-flex justify-content-end">
              {canEdit && (
                <Button
                  newClass={`whiteFont`}
                  btnName={`Submit`}
                  btnColor={`#b93160`}
                  style={{ width: "90px", borderRadius: "6px", color: "#fff", backgroundColor: "#b93160", marginBottom: "20px" }}
                  onClick={(e) => handleSubmit(e)}
                />
              )}
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default connect(null, {
  getSetting,
  updateSetting,
  handleToggleSwitch,
  getWithdraw,
})(Setting);
